export default __webpack_public_path__ + "static/media/Trident of the Gathering Storm.267fbbb3.jpg";